import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmSerialTypeForm from '../../../components/forms/FirearmSerialTypeForm';
import { useFirearmSerialTypeById, useUpdateFirearmSerialType } from '../../../hooks/useFirearmSerialTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmSerialTypeDTO } from '../../../services/apiClient';

const FirearmSerialTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmSerialTypeById(id!);
  const updateFirearmSerialType = useUpdateFirearmSerialType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Serial Types', href: '/admin/firearmserialtypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmSerialType.mutateAsync({ id: id!, data });
      navigate('/admin/firearmserialtypes');
    } catch (error) {
      console.error('Error updating FirearmSerialType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmserialtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmSerialType.Edit'
    >
        {entityData ? (
          <FirearmSerialTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmserialtypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmSerialTypeEdit;